import { render, staticRenderFns } from "./liCreateOrderV2.vue?vue&type=template&id=0383711e&scoped=true"
import script from "./liCreateOrderV2.vue?vue&type=script&lang=js"
export * from "./liCreateOrderV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.23_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_t2asupwbbn4g4z6gf7kzzdxifm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383711e",
  null
  
)

export default component.exports